// ┏━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┓
// ┃ ██████ ██████ ██████       █      █      █      █      █ █▄  ▀███ █       ┃
// ┃ ▄▄▄▄▄█ █▄▄▄▄▄ ▄▄▄▄▄█  ▀▀▀▀▀█▀▀▀▀▀ █ ▀▀▀▀▀█ ████████▌▐███ ███▄  ▀█ █ ▀▀▀▀▀ ┃
// ┃ █▀▀▀▀▀ █▀▀▀▀▀ █▀██▀▀ ▄▄▄▄▄ █ ▄▄▄▄▄█ ▄▄▄▄▄█ ████████▌▐███ █████▄   █ ▄▄▄▄▄ ┃
// ┃ █      ██████ █  ▀█▄       █ ██████      █      ███▌▐███ ███████▄ █       ┃
// ┣━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┫
// ┃ Copyright (c) 2017, the Perspective Authors.                              ┃
// ┃ ╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌ ┃
// ┃ This file is part of the Perspective library, distributed under the terms ┃
// ┃ of the [Apache License 2.0](https://www.apache.org/licenses/LICENSE-2.0). ┃
// ┗━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┛

import type * as wasm_module_type from "../../dist/wasm/perspective-viewer.js";
import { load_wasm_stage_0 } from "@perspective-dev/client/src/ts/wasm/decompress.ts";

// @ts-ignore
import * as worker_url from "./perspective-viewer.worker";

export async function init_client(
    wasm_binary:
        | Promise<Response | ArrayBuffer | Uint8Array>
        | Response
        | ArrayBuffer
        | Uint8Array,
    wasm_module?: typeof wasm_module_type,
) {
    // @ts-ignore
    const url = await worker_url.getWorkerURL();
    const [wasm_module2, module_or_path] = await Promise.all([
        wasm_module === undefined ? import(url) : wasm_module,
        load_wasm_stage_0(wasm_binary).then((unzipped) =>
            WebAssembly.compile(unzipped as BufferSource),
        ),
    ]);

    await wasm_module2.default({ module_or_path });
    await wasm_module2.init(module_or_path, url);
}
